
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.883 37.708a1.112 1.112 0 101.573-1.572 1.112 1.112 0 00-1.573 1.572zM24.6 34.562L35.24 23.916a1.112 1.112 0 00-1.573-1.572L23.028 32.989a1.11 1.11 0 001.212 1.818c.135-.057.258-.141.36-.246z","fill":"#172642"}}),_c('path',{attrs:{"d":"M17.936 30.22L8.36 39.797c-.11.11-.197.243-.252.39v.01l-4.622 12.5a1.112 1.112 0 001.43 1.428L17.4 49.488c.15-.057.286-.144.4-.256l9.574-9.574L44.44 56.823a1.114 1.114 0 001.578-.001l11.006-11.108a1.112 1.112 0 000-1.57L39.95 27.075l12.569-12.57a6.67 6.67 0 10-9.433-9.433L30.515 17.64 13.438.565a1.11 1.11 0 00-1.568 0l-11.116 11a1.112 1.112 0 000 1.58L17.936 30.22zM31.3 20l6.933-6.931 6.29 6.288-6.931 6.93-20.585 20.584-6.284-6.29L31.3 20.002zM42.165 9.14l6.289 6.29-2.36 2.359-6.288-6.29 2.359-2.358zM10.41 49.709L7.89 47.186l1.7-4.591 5.409 5.409-4.588 1.704zm-3.37-.226l1.077 1.077-1.711.635.634-1.712zm33.915-18.256l-4.764 4.763a1.112 1.112 0 001.572 1.573l4.76-4.764 3.367 3.367-3.187 3.19a1.112 1.112 0 101.573 1.574l3.19-3.188 3.368 3.368-4.763 4.763a1.112 1.112 0 001.572 1.569l4.764-4.762 2.257 2.258c-9.388 9.378-9.441 9.524-9.441 9.524L28.94 38.083l9.436-9.436 2.579 2.579zm9.99-24.585a4.444 4.444 0 010 6.289l-.92.92-6.29-6.286.922-.921a4.444 4.444 0 016.289-.002zM15.13 5.4l-4.763 4.76a1.112 1.112 0 101.573 1.574l4.763-4.762 3.366 3.368-3.19 3.189a1.113 1.113 0 101.572 1.573l3.19-3.19 3.144 3.143-4.76 4.762a1.11 1.11 0 00.355 1.824 1.111 1.111 0 001.218-.252l4.762-4.762 2.587 2.587-9.435 9.435L3.114 12.357s.154-.05 9.534-9.438l2.48 2.482z","fill":"#172642"}})])
          )
        }
      }
    